export default __webpack_public_path__ + "static/store-manager-0-bd22c98d175e85dafef8793228d03c92.png";